import { useState } from 'react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { postProviderSignIn } from '../lib/nativeAuth';

const CANCELLED = /canceled|cancel|1001|12501|popup_closed/i;

/** Apple/Google sign-in that asks before creating a new account. */
export const useProviderSignIn = (redirectTo = '/dashboard') => {
  const navigate = useNavigate();
  const { loginWithNativeResult } = useAuth();
  const [pending, setPending] = useState(null); // { provider, cred }
  const [busy, setBusy] = useState(false);

  const finish = (data) => {
    loginWithNativeResult(data);
    toast.success('Welcome!');
    navigate(redirectTo);
  };

  const signIn = async (provider, getCredential) => {
    let cred;
    try {
      cred = await getCredential();
      finish(await postProviderSignIn(provider, cred, false));
    } catch (e) {
      if (e?.code === 'no_account' && cred) {
        setPending({ provider, cred });
        return;
      }
      const msg = e?.message || 'Sign-in failed.';
      if (!CANCELLED.test(msg) && !CANCELLED.test(e?.error || '')) toast.error(msg);
    }
  };

  const confirmCreate = async () => {
    setBusy(true);
    try {
      finish(await postProviderSignIn(pending.provider, pending.cred, true));
      setPending(null);
    } catch (e) {
      toast.error(e?.message || 'Could not create the account.');
      setPending(null);
    } finally {
      setBusy(false);
    }
  };

  const chooseExisting = (showHint) => {
    if (showHint) {
      toast('Sign in with your email or the method you used before, then connect it in Settings → Sign-in methods.');
    }
    setPending(null);
  };

  return { signIn, pending, busy, confirmCreate, chooseExisting };
};

export default useProviderSignIn;
